import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class PerformanceService {
  http = inject(HttpClient);

  private eventQueue: { name: string, duration: number }[] = [];
  private activeEvents: Map<string, number> = new Map();
  private readonly COOKIE_NAME = 'acceptTelemetry';

  private API_URL = "/api/"

  constructor() {
    this.startInterval();

    if (window.location.hostname === "localhost") {
      this.API_URL = "https://beta.jar.games/api/";
    }
  }

  startEvent(name: string): string {
    const id = Math.random().toString(36).substring(7);
    this.activeEvents.set(id, performance.now());
    return id;
  }

  endEvent(id: string, name: string) {
    const startTime = this.activeEvents.get(id);
    if (startTime) {
      const duration = performance.now() - startTime;
      this.eventQueue.push({ name, duration });
      this.activeEvents.delete(id);
    }
  }

  trackDuration(name: string, duration: number) {
    this.eventQueue.push({ name, duration });
  }

  private startInterval() {
    setInterval(() => {
      this.sendEvents();
    }, 30000); // 30 seconds
  }

  private sendEvents() {
    if (this.eventQueue.length === 0) return;
    if (!this.hasAcceptedTelemetry()) {
      this.eventQueue = []; // Clear queue if telemetry not accepted
      return;
    }

    const eventsToSend = [...this.eventQueue];
    this.eventQueue = []; // Clear queue immediately

    this.http.post(this.API_URL + 'performance/track.php', { events: eventsToSend }).subscribe({
      error: (err) => console.error('Failed to send performance data', err)
    });
  }

  hasAcceptedTelemetry(): boolean {
    return this.getCookie(this.COOKIE_NAME) === 'true';
  }

  acceptTelemetry() {
    this.setCookie(this.COOKIE_NAME, 'true', 365);
  }

  declineTelemetry() {
    this.setCookie(this.COOKIE_NAME, 'false', 365);
  }

  getTelemetryStatus(): 'true' | 'false' | null {
    const val = this.getCookie(this.COOKIE_NAME);
    if (val === 'true') return 'true';
    if (val === 'false') return 'false';
    return null;
  }

  private setCookie(name: string, value: string, days: number) {
    let expires = "";
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  private getCookie(name: string): string | null {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }
}
